import classes from "../login.module.scss";

export const LoginFooter = () => {
  const year = new Date().getFullYear();

  return (
    <div className={classes["footer"]}>
      <h6>
        Hivery
        <span className={classes["copy-symbol"]}>&copy;</span>
        {year}
      </h6>
    </div>
  );
};
